export const SET_USER = "SET_USER"
export const LOG_OUT_USER = "LOG_OUT_USER"

export const setUser = user => ({
    type: SET_USER,
    payload: user
})

export const logOutUser = () => ({
    type: LOG_OUT_USER,
})
